"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Publish = exports.Subscribe = exports.ChildProcess = exports.CLI = exports.Wait = exports.Base = void 0;
const cli_1 = __importDefault(require("./cli"));
const queue_1 = __importDefault(require("./queue"));
const cli_api_1 = require("../cli-api");
Object.defineProperty(exports, "ChildProcess", { enumerable: true, get: function () { return cli_api_1.childProcess; } });
const watcher_1 = require("./watcher");
Object.defineProperty(exports, "Subscribe", { enumerable: true, get: function () { return watcher_1.Subscribe; } });
Object.defineProperty(exports, "Publish", { enumerable: true, get: function () { return watcher_1.Publish; } });
const lang_1 = require("../service/lang");
// 默认的生命周期阶段数组
const defaultLifecycle = ['init', 'prompt', 'default', 'writing', 'install', 'end'];
const Wait = (0, queue_1.default)();
exports.Wait = Wait;
const CLI = (0, cli_1.default)();
exports.CLI = CLI;
const Base = {
    // 状态对象
    state: {},
    /**
     * 扩展并注册运行时生命周期任务
     * @param runtimeLifecycle 运行时生命周期对象
     */
    extends(runtimeLifecycle) {
        defaultLifecycle.forEach(task => {
            if (Object.prototype.hasOwnProperty.call(runtimeLifecycle, task)) {
                const taskFn = runtimeLifecycle[task];
                if (taskFn) {
                    Wait.enqueue(taskFn);
                }
            }
        });
        CLI.loading.succeed(lang_1.Lang.CORE_STRTUP_DONE);
        Wait.next();
    },
};
exports.Base = Base;
exports.default = {
    Base,
    Wait,
    CLI,
    ChildProcess: cli_api_1.childProcess,
    Subscribe: watcher_1.Subscribe,
    Publish: watcher_1.Publish,
};
